const de = {
  year: 'Jahr',
  semesterType: 'Semestertyp',
  examRegistration: 'Prüfungsanmeldung',
  edit: 'Bearbeiten'
};

export default de;
export type IOSettingsTranslation = typeof de;
